import { useAuthUser } from "@/lib/auth-context";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { safeRedirect } from "@/lib/safe-redirect";
import { RouteSpinner } from "@/components/RouteSpinner";

export function RequireAuth(): JSX.Element {
  const { isLoaded, user } = useAuthUser();
  const location = useLocation();
  if (!isLoaded) return <RouteSpinner />;
  if (!user) {
    const target = encodeURIComponent(safeRedirect(location.pathname + location.search));
    return <Navigate to={`/signin?redirect_url=${target}`} replace />;
  }
  return <Outlet />;
}
